import TextLink from 'LuxKit/TextLink'
import type { ReactNode } from 'react'
import styled from 'styled-components'

const URL_PATTERN = /https?:\/\/[^\s]+/g
const TRAILING_URL_PUNCTUATION_PATTERN = /[),.;:!?]+$/

const ImportantInformationLink = styled(TextLink)`
  && {
    font-size: inherit;
    line-height: inherit;
    overflow-wrap: anywhere;
  }
`

export function normaliseCarHireImportantInformationParagraph(paragraph: string): string {
  return paragraph
    .replace(/^[\s•⁃]+/, '')
    .replace(/\s+/g, ' ')
    .trim()
}

function renderLinkedText(text: string): Array<ReactNode> {
  const parts: Array<ReactNode> = []
  let lastIndex = 0

  for (const match of text.matchAll(URL_PATTERN)) {
    const url = match[0]
    const startIndex = match.index ?? 0
    const trailingPunctuation = url.match(TRAILING_URL_PUNCTUATION_PATTERN)?.[0] ?? ''
    const href = trailingPunctuation ? url.slice(0, -trailingPunctuation.length) : url

    if (startIndex > lastIndex) {
      parts.push(text.slice(lastIndex, startIndex))
    }

    parts.push(
      <ImportantInformationLink
        href={href}
        key={`${href}-${startIndex}`}
        rel="noopener noreferrer"
        target="_blank"
        weight="regular"
      >
        {href}
      </ImportantInformationLink>,
    )

    if (trailingPunctuation) {
      parts.push(trailingPunctuation)
    }

    lastIndex = startIndex + url.length
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return parts
}

interface Props {
  text: string
}

function CarHireImportantInformationText(props: Props) {
  const { text } = props

  return <>{renderLinkedText(text)}</>
}

export default CarHireImportantInformationText
